<template>
	<div class="ctext">
		<div class="h4">商家主体及经营资质上传说明</div>
		<div>直达运动平台为运动鞋服、运动器械类专业批发 B2B 平台，为规范经营秩序，依据相关法规，所有入驻商家均需上传真实、合法、有效的主体与经营资质，审核通过后方可开通经营权限，未按要求上传或审核不通过的，无法完成入驻。具体要求如下：</div>
		<div>一、主体资质上传要求</div>
		<div>商家按自身主体类型对应上传，文件清晰无篡改、信息完整且在有效期内，经营范围需含运动鞋服 / 运动器械相关批发 / 销售类目。</div>
		<div>1.企业主体：上传营业执照（正 / 副本）扫描件 / 照片变更需提供相关证明。</div>
		<div>2.个体工商户：上传个体工商户营业执照（正 / 副本）扫描件 / 照片，网络经营场所登记的需与入驻信息匹配，其余要求同企业主体。</div>
		<div>3.特殊情形：个人从事运动鞋服 / 运动器械零星小额批发（年交易额≤10 万元）或销售自产相关手工制品，免传营业执照，需提交个人身份证正反面照片及相关情形自我声明。</div>
		<div>二、经营资质上传要求</div>
		<div>基础资质所有商家必传，特殊运动器械品类按实际经营类目上传专项资质，未取得的不得经营相关品类。</div>
		<div>1.基础经营资质（通用）：经营品牌类商品的，上传品牌方批发授权书或所经营产品完整的采购链路。</div>
		<div>三、资质上传通用规范</div>
		<div>1.格式支持 JPG、PNG、PDF，单文件≤10M，内容清晰、印章 / 二维码无遮挡，不得拼接篡改；</div>
		<div>2.企业资质需加盖鲜章，个体工商户由经营者签字按手印，品牌授权书需加盖品牌方鲜章；</div>
		<div>3.所有资质核心信息（名称、统一社会信用代码等）与入驻信息、主体资质完全一致；</div>
		<div>4.资质变更 / 过期的，需在变更完成后 10 个工作日内、资质到期前 30 日内完成平台更新上传。</div>
		<div>四、资质审核与违规处理</div>
		<div>1.审核时效：提交后 1-3 个工作日完成审核，结果通过平台消息、短信通知，审核不通过将告知补正原因，商家需按要求重新提交；</div>
		<div>2.违规处理：上传虚假资质、冒用品牌资质的，永久限制入驻；超资质经营、资质过期 / 信息不符未及时更新的，暂停经营权限，逾期未补正的清退店铺，所有违规后果由商家自行承担。</div>
		<div>五、温馨提示</div>
		<div>1.商家对上传资质的真实性、合法性承担全部法律责任，因资质问题引发的纠纷、处罚由商家自行负责；</div>
		<div>2.平台对资质信息严格保密，仅用于核验、备案及监管部门核查等法定用途；</div>
		<div>3.资质相关疑问可通过平台商家客服热线、在线客服咨询。</div>
		<div>本说明最终解释权归山西弛方电子商务有限公司所有，平台将根据法规及运营需要适时调整要求并公告。</div>
	</div>
</template>

<script>
	export default {
		name: 'Ctext',
		data() {
			return {}
		}
	}
</script>

<style scoped lang="less">
	.ctext {
		width: 100%;
		display: flex;
		flex-direction: column;
		.h4 {
			width: 100%;
			text-align: center;
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/common/ctext.vue